import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["subdomain"];
import { fetchQuickRegister } from '../repositories/monolith-csharp/users/v1/quick-register';
export function register(httpApi, parameters) {
  var subdomain = parameters.subdomain,
    restParameters = _objectWithoutProperties(parameters, _excluded);
  return fetchQuickRegister({
    httpApi: httpApi,
    parameters: restParameters,
    config: {
      subdomain: subdomain,
      bodyAsEncodeString: true,
      requestConfig: {
        headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        withCredentials: true
      }
    }
  });
}